/*
 * A little piece of hacky code that
 * re-styles the press buttons if 
 * one contains over an amount of characters
 * 
 * @author BarrelNY
 *
 */
var Press = {
	init:function(){
		
		var templates = [
			'body.blog'
		].join();
		
		if (!$(templates).length) return;
		
		var $btn    = $('.press-block-links a')
		,   longest = 0
		,   max     = 12;
		
		for (b in $btn){
			var txt = $btn[b].innerHTML;
			
			if ( !txt )
				continue;
				
			if (txt.length > max)
				$($btn[b]).addClass('lg');
			
			if (txt.length > longest)
				longest  = txt.length;
		}
		
		if (longest > max)
			$('.press-block-links').addClass('contains-lg')
	}
}

module.exports = Press;

